/*
 * @Author: etong
 * @Date: 2021-05-28 16:12:52
 * @LastEditTime: 2021-06-10 15:40:26
 * @LastEditors: your name
 * @Description:
 * @FilePath: \oak\src\store\modules\vmRouteQuene.js
 * Think first, Program later
 */
const vmRouteQueneTemp = {
    state: {
        vmRouteQuene: []
    },
    mutations: {
        // 设置路由对应的vm实例
        SET_ROUTE_VM_QUENE: ( state, data ) => {
            let { vmRouteQuene } = state;
            let { code, _vm } = data;
            let codes = vmRouteQuene.map(item=>item.code);
            if( code ) {
                if( !codes.includes( code ) ) {
                  vmRouteQuene.push({
                        code,
                        _vm
                    })
                } else {
                    if ( !_vm ) return;
                    for( var i =0 ;i<vmRouteQuene.length;i++) {
                        if( vmRouteQuene[i].code === code ) {
                          vmRouteQuene[i]['_vm'] = _vm;
                        }
                    }
                }

            }
        },
        // 清空路由实例
        CLEAR_ROUTE_VM_QUENE: ( state, data ) => {
            state.vmRouteQuene = []
        },
    },

}

export default vmRouteQueneTemp
